import { useFormikContext } from 'formik'
import { ThailandAddressType } from '@components/interfaces/AddressSearchSelect'
import { WriterFormType } from '@models/writer/WriterFormType'
import {
  CertificateAddressProps,
  WithCertificateAddressProps,
} from './interface'

export function withCertificateAddress(
  Component: React.FC<CertificateAddressProps>
) {
  function WithCertificateAddress({
    residenceOptions,
    countryOptions,
  }: WithCertificateAddressProps) {
    const { values, setFieldValue } = useFormikContext<WriterFormType>()

    function handleAddressChange(data: ThailandAddressType) {
      setFieldValue('certificateProvince', data.province)
      setFieldValue('certificateDistrict', data.amphoe)
      setFieldValue('certificateSubDistrict', data.district)
      setFieldValue('certificatePostcode', String(data.zipcode))
    }

    const componentProps = {
      values,
      residenceOptions,
      countryOptions,
      handleAddressChange,
    }
    return <Component {...componentProps} />
  }

  return WithCertificateAddress
}
